import Navigation from "@/components/layout/Navigation";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Ventures from "@/components/sections/Ventures";
import Projects from "@/components/sections/Projects";
import Services from "@/components/sections/Services";
import Stack from "@/components/sections/Stack";
import Approach from "@/components/sections/Approach";
import Blog from "@/components/sections/Blog";
import Contact from "@/components/sections/Contact";
import CursorGlow from "@/components/effects/CursorGlow";

const Home = () => {
    return (
        <>
            <CursorGlow />
            <Navigation />
            <main className="relative z-10">
                <Hero />
                <About />
                <Ventures />
                <Projects />
                <Services />
                <Stack />
                <Approach />
                <Blog />
                <Contact />
            </main>
            <Footer />
        </>
    );
};

export default Home;
